import { graphql } from '@/generated/gql';

export const NEGOTIATED_QUOTE_QUERY = graphql(/* GraphQL */ `
  query NegotiatedQuote($id: UUID!) {
    tesseract {
      negotiationCase(id: $id) {
        isMaskedBidding
        id
        status
        processStatus
        options {
          id
          supplierInteractionMode
        }
        negotiatedQuote {
          id
          createdAt
          currency
          supplierReference
          totalValue
          lineItems {
            id
            title
            description
            deliveryLocationId
            organizationId
            commodityId
            unitId
            position
            pricePerUnit
            quantity
            totalValue
            shipmentTerms {
              earlyDeliveryAt
              lateDeliveryAt
            }
            discount
            totalDiscountedValue
            discountedPricePerUnit
            supplierComment {
              variant
              text
            }
            status
          }
          paymentTerms {
            daysToPayment
            discount
          }
          shipmentTerms {
            earlyDeliveryAt
            lateDeliveryAt
          }
          discount
          totalDiscountedValue
          totalPriceDiscount
          buyerReply {
            text
            userId
          }
          supplierComment {
            text
            variant
          }
          hasSupplierComment
        }
      }
    }
  }
`);
